module.exports = __webpack_public_path__ + "static/media/asseguroulogo.281e6694.svg";